import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import OptiFleetLogo from "../common/assets/OptifleetLogo";
import { SPACING_60 } from "../common/styles/spacing";

const ErrorContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0 auto;

    #logo_optifleet {
    width: 40%;
    margin: ${SPACING_60};
    }
`;

const ErrorMessage = styled.h1`
    display: flex;
    width: 100%;
    justify-content: center;
    text-align: center;
`;

export default () => {
    const { t } = useTranslation();

    return (
        <ErrorContainer>
            <OptiFleetLogo />
            <ErrorMessage>
                {t("error.errorMessage1")}
                <br />
                {t("error.errorMessage2")}
            </ErrorMessage>
        </ErrorContainer>
    );
};
